module.exports = __webpack_public_path__ + "img/img_3.c902da9d.png";